export default [
    {
        path: "/catalogue-items",
        name: "catalogue-items",
        component: () => import("@/views/modules/catalogue/items/list"),
        meta: {
            requiresAuth: true,
            layout: "app",
            title: "Catalogue",
            breadcrumb: [
                { text: "Home", to: { name: "home" } },
                { text: "Catalogue Manage" }
            ]
        },
        children: [
            {
                path: "/catalogue-item/create",
                name: "catalogue-item-create",
                component: () =>
                    import("@/views/modules/catalogue/items/create"),
                meta: {
                    sidebarToggle: true,
                    requiresAuth: true,
                    layout: "app",
                    title: "Catalogue Item Create",
                    breadcrumb: [
                        { text: "Home", to: { name: "home" } },
                        { text: "Catalogue", link: "/catalogue-items" },
                        { text: "Create" }
                    ]
                }
            },
            {
                path: "/catalogue-item/:id/edit",
                props: true,
                name: "catalogue-item-edit",
                component: () => import("@/views/modules/catalogue/items/edit"),
                meta: {
                    sidebarToggle: true,
                    requiresAuth: true,
                    layout: "app",
                    title: "Catalogue Item Edit",
                    breadcrumb: [
                        { text: "Home", to: { name: "home" } },
                        {
                            text: "Catalogue",
                            to: { name: "catalogue-item-show" },
                            param: "id"
                        },
                        { text: "Edit" }
                    ]
                }
            },
            {
                path: "/catalogue/:id/show",
                props: true,
                name: "catalogue-item-show",
                component: () => import("@/views/modules/catalogue/items/show"),
                meta: {
                    sidebarToggle: true,
                    requiresAuth: true,
                    layout: "app",
                    title: "Catalogue Item Details",
                    breadcrumb: [
                        { text: "Home", to: { name: "home" } },
                        { text: "Catalogue", to: { name: "catalogue-items" } },
                        { text: "Details" }
                    ]
                }
            }
        ]
    },
    {
        path: "/catalogue-share",
        name: "catalogue-share",
        component: () => import("@/views/modules/catalogue/share/list"),
        meta: {
            requiresAuth: true,
            layout: "app",
            title: "Catalogue",
            breadcrumb: [
                { text: "Home", to: { name: "home" } },
                { text: "Catalogue Share" }
            ]
        },
        children: [
            {
                path: "/catalogue-share/:id/show",
                props: true,
                name: "catalogue-share-item-show",
                component: () => import("@/views/modules/catalogue/share/show"),
                meta: {
                    sidebarToggle: true,
                    requiresAuth: true,
                    layout: "app",
                    title: "Catalogue Item Details",
                    breadcrumb: [
                        { text: "Home", to: { name: "home" } },
                        { text: "Catalogue", to: { name: "catalogue-share" } },
                        { text: "Details" }
                    ]
                }
            },
            {
                path: "/catalogue-share/pdf",
                props: true,
                name: "catalogue-share-pdf",
                component: () => import("@/views/modules/catalogue/share/pdf"),
                meta: {
                    sidebarToggle: true,
                    requiresAuth: true,
                    layout: "app",
                    title: "Catalogue PDF",
                    breadcrumb: [
                        { text: "Home", to: { name: "home" } },
                        { text: "Catalogue", to: { name: "catalogue-share" } },
                        { text: "PDF" }
                    ]
                }
            }
        ]
    }
];
